"use strict";

import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Fields } from "Constants/objects";

var DecorationElement =
/*#__PURE__*/
function () {
  /**
   *
   * @param {object} decor FormDecorationElements
   */
  function DecorationElement(decor) {
    _classCallCheck(this, DecorationElement);

    _defineProperty(this, "_decor", null);

    this._decor = decor;
  }

  _createClass(DecorationElement, [{
    key: "id",
    get: function get() {
      return this._decor[Fields.ID];
    }
  }, {
    key: "formID",
    get: function get() {
      return this._decor[Fields.FormID];
    }
  }, {
    key: "groupID",
    get: function get() {
      return this._decor[Fields.GroupID];
    }
  }, {
    key: "name",
    get: function get() {
      return this._decor[Fields.Name];
    }
  }, {
    key: "title",
    get: function get() {
      return this._decor[Fields.Title];
    }
  }, {
    key: "isVisible",
    get: function get() {
      return this._decor[Fields.IsVisible];
    }
  }, {
    key: "order",
    get: function get() {
      return this._decor[Fields.Order];
    }
  }, {
    key: "displayType",
    get: function get() {
      return this._decor[Fields.DisplayType];
    }
  }, {
    key: "lineCount",
    get: function get() {
      return this._decor[Fields.LineCount];
    }
  }, {
    key: "style",
    get: function get() {
      return this._decor[Fields.Style];
    }
  }]);

  return DecorationElement;
}();

export { DecorationElement as default };